/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import { FETCH_LANGUAGES_REQUEST, FETCH_LANGUAGES_SUCCESS, FETCH_LANGUAGES_FAILURE } from 'constants/ActionTypes';

/**
 * @typedef {{
 *   data: string[],
 *   isFetching: boolean,
 * }} LanguageReducer
 */

const initialState = {
  data: [],
  isFetching: false,
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case FETCH_LANGUAGES_REQUEST:
      draft.isFetching = true;
      break;
    case FETCH_LANGUAGES_SUCCESS:
      draft.isFetching = false;
      draft.data = action.languages;
      break;
    case FETCH_LANGUAGES_FAILURE:
      draft.isFetching = false;
      break;
    default:
  }
}, initialState);

export default reducer;
